<template>
  <div class="education-column-columnist-list-component">
    <router-link class="education-column-columnist-item"
                 v-for="item in list"
                 :key="item.id"
                 :to="{ name: 'EducationColumnColumnistDetail', params: { id: item.id } }"
    >
      <div class="education-column-columnist-content">
        <ym-avatar class="education-column-columnist-avatar"
                   :avatar="item.avatar"
        />
        <h3 class="education-column-columnist-name ym-line-ellipsis">{{ item.name }}</h3>
        <div class="education-column-columnist-title ym-two-line-ellipsis">
          {{ item.title }}
        </div>
      </div>
      <ym-button class="education-column-columnist-btn"
                 size="extra-small"
                 round
      >
        查 看
      </ym-button>
    </router-link>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import YmAvatar from '@/components/Avatar';

  export default {
    name: 'EducationColumnColumnistList',
    components: {
      'ym-button': Button,
      YmAvatar,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-columnist {
    @columnist-item-width: 220px;
    @columnist-item-height: 390px;
    @columnist-margin: 15/2px;

    &-list-component {
      padding: @size-base;
      margin: -@columnist-margin;
      line-height: 0;
      font-size: 0;
    }

    &-item {
      box-sizing: border-box;
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: @columnist-item-width;
      height: @columnist-item-height;
      overflow: hidden;
      vertical-align: middle;
      text-align: center;
      padding: @size-base @size-medium @size-small;
      margin: @columnist-margin;
      background-color: @color-white;
      border-radius: @education-column-border-radius;
    }

    &-content {
      width: 100%;
      overflow: hidden;
    }

    @columnist-avatar-size: 140px;
    &-avatar {
      margin: 0 auto @size-small;
      width: @columnist-avatar-size;
      height: @columnist-avatar-size;
    }

    &-name {
      margin: 0 0 @size-extra-small;
      font-size: @font-size-medium;
      line-height: 1;
    }

    &-title {
      font-size: @font-size-small;
      line-height: 1.4;
      color: @color-text-lighter;
    }

    &-btn {
      width: 100%;
      font-size: @font-size-small;
      color: @color-primary;
      background-color: @color-primary-lighter;
    }
  }
</style>
